import React, {useMemo} from "react";
import {useTarifsOptions} from "../estimate-invoice";
import {NavLink} from "react-router-dom";
import {generateTrackTokens} from "./api";
import {useEvents} from "../event";
import Select from "react-select";

export default function FormDetails({
                                      isLoaded,
                                      booking,
                                      selectedFolder,
                                      errorPrice,
                                      folders,
                                      calculatedPrice,
                                      loadingPrice,
                                      handleChange,
                                      setBookingField,
                                      userInfos,
                                    }) {
  const tarifOptions = useTarifsOptions();
  const {events} = useEvents();

  const eventOptions = useMemo(() => {
    return events.map((event) => ({
      value: event.id, label: event.name, data: event,
    }));
  }, [events]);

  const folderOptions = useMemo(() => {
    let res = folders.map((folder) => ({
      value: folder.id, label: folder.name, data: folder,
    }));

    res.unshift({value: "", label: "Aucun", data: null});

    return res;
  }, [folders]);

  let displayDistance = "";
  let displayDuration = "";
  if (booking.distance) {
    displayDistance = booking.distance / 1000;
    // Round to the nearest 100
    displayDistance = Math.floor(displayDistance * 100) / 100;
    displayDistance += " km";
  }
  if (booking.duration) {
    let hours = Math.floor(booking.duration / 60 / 60);
    let minutes = Math.floor(booking.duration / 60) - hours * 60;
    displayDuration = hours + "h " + minutes + "m";
  }

  const bookingFolder = folders.find((f) => f.id === booking.folder_id);
  const folderTarifName = tarifOptions.find((t) => t.value === bookingFolder?.tarif)?.label;
  const folderTarifProductName = tarifOptions
    .find((t) => t.value === bookingFolder?.tarif)
    ?.data?.products?.find((p) => p.id === bookingFolder.tarif_product)?.label;

  const selectedTarif = tarifOptions.find((t) => t.value === booking.tarif)?.data;

  async function onClickGenerateTrackTokens(e) {
    e.preventDefault();
    await generateTrackTokens(userInfos.jwt, booking.id);
    window.location.reload();
  }

  function getPriceText(field) {
    if (booking.sharedBy) return "";

    if (loadingPrice) {
      return "Calcul en cours...";
    }
    if (errorPrice) {
      return errorPrice + " pour calculer automatiquement";
    }
    switch (field) {
      case "client":
      case "partner":
        if (calculatedPrice[field]) {
          let amount = new Intl.NumberFormat("fr-FR", {
            style: "currency", currency: "EUR",
          }).format(calculatedPrice[field]);

          return (<>
              Valeur calculée:{" "}
              <button
                className="text-primary bg-transparent border-0 p-0"
                onClick={(e) => {
                  e.preventDefault();
                  setBookingField(field === "client" ? "amount" : "driver_price", calculatedPrice[field]);
                }}
              >
                {amount}
              </button>
            </>);
        }
        break;
      case "distance":
      case "duration":
        // For distance and duration, no indication needed as values are automatically applied
        return "";
        break;
      default:
        return "";
    }
  }

  function TrackLink({jwt}) {
    const uid = booking.sharedBy ? booking.sharedBy : userInfos.uid;
    if (jwt) {
      return (<NavLink to={`/track/${uid}/${jwt}`} target="_blank">
          Lien
        </NavLink>);
    } else if (!booking.sharedBy) {
      return (<button
          className="btn btn-primary"
          onClick={onClickGenerateTrackTokens}
        >
          Créer le lien de suivi
        </button>);
    } else {
      return (<span className="text-muted">
          Le lien de suivi n'est pas encore généré
        </span>);
    }
  }

  if (!isLoaded) return (<div className="kt-section kt-section--first">
      <p>Chargement...</p>
    </div>);

  return (<div className="kt-section kt-section--first">
      <div className="kt-section__body">
        {booking.id ? (<>
            <div className="form-group row">
              <label className="col-lg-3 col-form-label">
                Lien de suivi (chauffeur):
              </label>
              <div className="col-lg-6">
                <TrackLink jwt={booking.driverJwt}/>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-lg-3 col-form-label">
                Lien de suivi (client):
              </label>
              <div className="col-lg-6">
                <TrackLink jwt={booking.clientJwt}/>
              </div>
            </div>
          </>) : null}
        <div className="form-group row">
          <label className="col-lg-3 col-form-label">Dossier:</label>
          <div className="col-lg-6">
            <Select
              options={folderOptions}
              value={selectedFolder ? {
                value: selectedFolder.id, label: selectedFolder.name, data: selectedFolder,
              } : null}
              onChange={(obj) => {
                setBookingField("folder_id", obj.value);
                if (obj.data?.tarif && !booking.tarif) setBookingField("tarif", obj?.data?.tarif);
                if (obj.data?.tarif_product && !booking.tarif_product) setBookingField("tarif_product", obj?.data?.tarif_product);
              }}
              isDisabled={booking.sharedBy}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-lg-3 col-form-label">Type de trajet *</label>
          <div className="col-lg-6">
            <select
              name="type"
              className="form-control"
              onChange={handleChange}
              disabled={booking.sharedBy}
            >
              <option value="" selected={booking.type === ""}>
                Sélectionnez le type de trajet
              </option>
              <option value="one_way" selected={booking.type === "one_way"}>
                Distance
              </option>
              <option value="hourly" selected={booking.type === "hourly"}>
                A l'heure
              </option>
              <option value="flat" selected={booking.type === "flat"}>
                Forfait
              </option>
            </select>
          </div>
        </div>
        {booking.type === "hourly" && <div className="form-group row">
          <label className="col-lg-3 col-form-label">
            Durée du trajet (à l'heure):
          </label>
          <div className="col-lg-6">
            <input
              type="text"
              className="form-control"
              name="num_hours"
              value={booking.num_hours}
              onChange={handleChange}
              disabled={booking.sharedBy}
            />
          </div>
        </div>}
        {!booking.sharedBy && (<>
            <div className="form-group row">
              <label className="col-lg-3 col-form-label">Tarif</label>
              <div className="col-lg-6">
                <select
                  name="tarif"
                  className="form-control"
                  value={booking.tarif || ""}
                  onChange={handleChange}
                >
                  <option value="">
                    Sélectionnez le tarif
                  </option>
                  {tarifOptions.map((option) => (<option
                      key={option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>))}
                </select>
                {folderTarifName && (<small className="text-sm text-muted">
                    Tarif du dossier sélectionné:{" "}
                    <button
                      className="text-primary bg-transparent border-0 p-0"
                      onClick={(e) => {
                        e.preventDefault();
                        setBookingField("tarif", bookingFolder.tarif)
                      }}
                    >
                      {folderTarifName}
                    </button>
                  </small>)}
              </div>
            </div>
            {booking.tarif && selectedTarif && selectedTarif?.products?.length > 3 && (<div className="form-group row">
                <label className="col-lg-3 col-form-label">
                  Tarif → Produit
                </label>
                <div className="col-lg-6">
                  <select
                    name="tarif_product"
                    className="form-control"
                    value={booking.tarif_product || ""}
                    onChange={handleChange}
                  >
                    <option value="">
                      Aucun
                    </option>
                    {selectedTarif.products.slice(3).map((product) => (<option
                        key={product.id}
                        value={product.id}
                      >
                        {product.label}
                      </option>))}
                  </select>
                  {folderTarifProductName && (<small className="text-sm text-muted">
                      Produit du dossier sélectionné:{" "}
                      <button
                        className="text-primary bg-transparent border-0 p-0"
                        onClick={(e) => {
                          e.preventDefault();
                          setBookingField("tarif_product", bookingFolder.tarif_product);
                        }}
                      >
                        {folderTarifProductName}
                      </button>
                    </small>)}
                </div>
              </div>)}
            <div className="form-group row">
              <label className="col-lg-3 col-form-label">Evènement:</label>
              <div className="col-lg-6">
                <Select
                  options={eventOptions}
                  value={booking?.event?.id ? {
                    value: booking.event.id, data: booking.event, label: booking.event.name,
                  } : null}
                  onChange={(obj) => setBookingField("event", obj.data)}
                />
              </div>
            </div>
          </>)}
        <div className="form-group row">
          <label className="col-lg-3 col-form-label">Status</label>
          <div className="col-lg-6">
            <select
              name="status"
              className="form-control"
              onChange={handleChange}
              disabled={booking.sharedBy}
            >
              <option value="" selected={booking.status === ""}>
                Sélectionnez le status
              </option>
              <option value="Paid" selected={booking.status === "Paid"}>
                Payé
              </option>
              <option value="Unpaid" selected={booking.status === "Unpaid"}>
                Non Payé
              </option>
              <option
                value="Cancelled"
                selected={booking.status === "Cancelled"}
              >
                Annulé
              </option>
            </select>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-lg-3 col-form-label">Moyen de paiement:</label>
          <div className="col-lg-6">
            <select
              name="payment_method"
              className="form-control"
              onChange={handleChange}
              disabled={booking.sharedBy}
            >
              <option value="" selected={booking.payment_method === ""}>
                Sélectionnez le moyen de paiement
              </option>
              <option
                value="Stripe"
                selected={booking.payment_method === "Stripe"}
              >
                Stripe
              </option>
              <option value="Cash" selected={booking.payment_method === "Cash"}>
                Espèce
              </option>
              <option
                value="onboardcard"
                selected={booking.payment_method === "onboardcard"}
              >
                CB à bord
              </option>
              <option
                value="transfer"
                selected={booking.payment_method === "transfer"}
              >
                Virement en compte
              </option>
              <option
                value="partneronboard"
                selected={booking.payment_method === "partneronboard"}
              >
                Encaissement à bord par partenaire
              </option>
            </select>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-lg-3 col-form-label">
            Prix{booking.sharedBy ? "" : " (client)"}:
          </label>
          <div className="col-lg-6">
            <input
              type="number"
              step="0.01"
              className="form-control"
              name="amount"
              value={booking.amount}
              onChange={handleChange}
            />
            <span className="text-sm text-muted">
              {booking.sharedBy ? (<>Prix initial: {booking.driver_price}</>) : (getPriceText("client"))}
            </span>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-lg-3 col-form-label">Distance:</label>
          <div className="col-lg-6">
            <input
              type="text"
              className="form-control"
              value={displayDistance}
              name="distance"
              disabled={true}
            />
            <span className="text-sm text-muted">
              {getPriceText("distance")}
            </span>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-lg-3 col-form-label">Durée:</label>
          <div className="col-lg-6">
            <input
              type="text"
              className="form-control"
              value={displayDuration}
              name="duration"
              disabled={true}
            />
            <span className="text-sm text-muted">
              {getPriceText("duration")}
            </span>
          </div>
        </div>
        {!booking.sharedBy && (<div className="form-group row">
            <label className="col-lg-3 col-form-label">
              Prix (chauffeur)
            </label>
            <div className="col-lg-6">
              <input
                type="number"
                step="0.01"
                className="form-control"
                name="driver_price"
                value={booking.driver_price}
                onChange={handleChange}
                disabled={booking.sharedBy}
              />
              <span className="text-sm text-muted">
                {getPriceText("partner")}
              </span>
            </div>
          </div>)}
      </div>
    </div>);
}
